import React from 'react';

const AgeIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.0217 30.4712V20.1544H13.6367V17.5106H19.3126V30.4712H16.0217ZM31.681 20.857C31.681 21.9847 31.0708 22.9831 30.054 23.5378C31.4775 24.1293 32.365 25.3681 32.365 26.8102C32.365 29.1397 30.2942 30.6188 27.0588 30.6188C23.8233 30.6188 21.7527 29.1582 21.7527 26.8658C21.7527 25.3866 22.7141 24.1293 24.2116 23.5378C23.1208 22.9276 22.4183 21.8924 22.4183 20.7646C22.4183 18.6938 24.2302 17.3812 27.0404 17.3812C29.8875 17.3812 31.681 18.7308 31.681 20.857ZM24.8587 26.533C24.8587 27.6239 25.6353 28.234 27.0588 28.234C28.4824 28.234 29.2774 27.6425 29.2774 26.533C29.2774 25.4608 28.4824 24.8505 27.0588 24.8505C25.6352 24.8505 24.8587 25.4607 24.8587 26.533ZM25.1916 21.0418C25.1916 21.9665 25.8571 22.4839 27.0588 22.4839C28.2606 22.4839 28.9261 21.9664 28.9261 21.0418C28.9261 20.0807 28.2606 19.5444 27.0588 19.5444C25.857 19.5444 25.1916 20.0807 25.1916 21.0418Z",
      fill: "white",
      fillOpacity: "0.6"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M37.8402 18.9736C38.3873 20.5885 38.6649 22.2774 38.6649 24.0001C38.6649 32.6376 31.6376 39.6649 22.9999 39.6649C14.3623 39.6649 7.33488 32.6376 7.33488 24.0001C7.33488 15.3623 14.3621 8.33522 22.9998 8.33522C24.7227 8.33522 26.4117 8.61254 28.0262 9.1599V5.67389C26.3954 5.22682 24.711 5 22.9999 5C12.5234 5 4 13.5234 4 24.0001C4 34.4767 12.5234 43.0001 22.9999 43.0001C33.4765 43.0001 41.9998 34.4767 41.9998 24.0001C41.9998 22.2891 41.7731 20.6046 41.326 18.9736H37.8402Z",
      fill: "white",
      fillOpacity: "0.6"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M36.8924 10.0968V6.45361H34.2727V10.0968H30.6514V12.7163H34.2727V16.3593H36.8924V12.7163H40.5354V10.0968H36.8924Z",
      fill: "white",
      fillOpacity: "0.6"
    }
  )
);
AgeIcon.displayName = "Icons.AgeIcon";

export { AgeIcon };
//# sourceMappingURL=AgeIcon.js.map
